
import React, { createContext, useContext, useState } from 'react';

// Context for managing safe dialog behaviors
interface SafeDialogContextType {
  safeMode: boolean;
  setSafeMode: (value: boolean) => void;
}

const SafeDialogContext = createContext<SafeDialogContextType>({
  safeMode: true,
  setSafeMode: () => {},
});

// Provider component
export const SafeDialogProvider: React.FC<{
  children: React.ReactNode;
  safeMode?: boolean;
}> = ({ children, safeMode = true }) => {
  const [safeModeState, setSafeModeState] = useState(safeMode);
  
  return (
    <SafeDialogContext.Provider 
      value={{
        safeMode: safeModeState,
        setSafeMode: setSafeModeState
      }}
    >
      {children}
    </SafeDialogContext.Provider>
  );
};

// Hook for accessing the context
export const useSafeDialog = () => {
  return useContext(SafeDialogContext);
};
